module.exports = __webpack_public_path__ + "img/template_image.a48685b8.jpg";